import { useDispatch } from "react-redux";
import { TFunction } from "i18next";
import { hideAlert, showAlert } from "../../../features/slices/applicationSlice";

const useAlerts = ({ translate }: { translate: ((key: string) => string) | TFunction }) => {
    const dispatch = useDispatch();

    const showCancelCarcinogenicReportAlert = ({ confirmAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.showCancelCarcinogenicReportAlert.title'),
                message: translate('alerts.showCancelCarcinogenicReportAlert.message'),
                icon: 'info',
                confirmText: translate('alerts.showCancelCarcinogenicReportAlert.confirmText'),
                confirmAction: confirmAction
            })
        );
    };

    const showSendCarcinogenicReportAlert = ({ confirmAction }: any) => {
        dispatch(
            showAlert({
                title: translate('alerts.sendPresentation.title'),
                message: translate('alerts.sendPresentation.message'),
                icon: 'info',
                confirmText: translate('alerts.sendPresentation.confirmText'),
                confirmAction: confirmAction
            })
        );
    };

    const showSendCarcinogenicReportFailAlert = () => {
        dispatch(
            showAlert({
                title: translate('alerts.sendPresentationsFail.title'),
                message: translate('alerts.sendPresentationsFail.message'),
                icon: 'error',
                confirmText: translate('alerts.sendPresentationsFail.confirmText'),
                confirmAction: () => dispatch(hideAlert())
            })
        );
    };


    return {
        showCancelCarcinogenicReportAlert,
        showSendCarcinogenicReportAlert,
        showSendCarcinogenicReportFailAlert
    };
};

export default useAlerts;